import React, { useEffect } from 'react';
import { Modal } from '../ui';

/**
 * Visionneuse photo plein écran (remplace Fancybox). Ouverte via `index`
 * (null = fermée), navigation clavier ← / → et boutons.
 */
export default function Lightbox({ images, index, onClose, onNavigate }) {
    useEffect(() => {
        if (index === null) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') onClose();
            if (e.key === 'ArrowLeft' && index > 0) onNavigate(index - 1);
            if (e.key === 'ArrowRight' && index < images.length - 1) onNavigate(index + 1);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [index, images.length, onClose, onNavigate]);

    if (index === null) return null;

    return (
        <Modal open onClose={onClose}>
            <img
                src={images[index].url}
                alt=""
                style={{ width: '100%', maxHeight: '70vh', objectFit: 'contain', borderRadius: 'var(--radius-md)', background: 'var(--ink-900)' }}
            />
            <div className="toolbar" style={{ justifyContent: 'space-between', marginTop: 16 }}>
                <button className="btn btn--secondary btn--sm" disabled={index === 0} onClick={() => onNavigate(index - 1)}>‹</button>
                <span className="text-muted text-sm">{index + 1} / {images.length}</span>
                <button className="btn btn--secondary btn--sm" disabled={index === images.length - 1} onClick={() => onNavigate(index + 1)}>›</button>
            </div>
        </Modal>
    );
}
